module.exports = __webpack_public_path__ + "static/media/wanon.67a313d6.png";